export default {
  to: "/renewals/registrations",
  order: 3,
  icon: "mdi-window-restore",
  title: "Renewals",
  disabled: false,
  value: 0,
};
